import { Task } from '@lit-labs/task';
import { request } from '../request.js';
import { TaskController } from './task.js';

/**
 * @typedef {import('lit').LitElement} LitElement
 */

export class ConnectProductsController extends TaskController {
  /**
   * @param {LitElement} host
   */
  constructor(host) {
    super();

    this.task = new Task(
      host,
      async ([account]) => {
        const products = await request(
          'GET',
          `/connect-accounts/${account}/products`
        );
        return products;
      },
      () => [host.getAttribute('account')]
    );
  }
}
